import React from "react";
import { BASE_URL } from "../../../Utlils";
import { useGlobalContext } from "../../../Contexts/GlobalContext";

const Postback = ({ user, setUser }) => {
  const { organization } = useGlobalContext();
  const tableData = [
    { operation: "Success/Complete", status: 10, type: "GET" },
    { operation: "Failure/Terminate", status: 20, type: "GET" },
    { operation: "Security Terminate", status: 30, type: "GET" },
    { operation: "Quota Full", status: 40, type: "GET" },
  ];
  return (
    <div className="w-full flex flex-col gap-6 h-full py-5">
      <div className="pb-6 border-b border-gray-200">
        <h1 className="text-[#0226BE] text-[28px] font-[600] mb-2">
          Post Back URLs
        </h1>
        <p className="text-gray-600 text-[14px]">Server-side endpoints for survey completion callbacks</p>
      </div>
      <div className="space-y-4">
        <h1 className="text-[#1a1a1a] text-[18px] font-[600]">
          Endpoints
        </h1>
        <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
          <div className="w-full overflow-x-auto containerScroll">
            <table className="whitespace-nowrap text-left w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Type
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Operation
                  </th>
                  <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                    Endpoint
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData?.map((d, i) => (
                  <tr
                    className="border-b border-gray-100 transition-all hover:bg-blue-50"
                    key={i}
                  >
                    <td className="px-4 py-4 capitalize text-green-600 font-[600] text-[14px]">
                      {d?.type}
                    </td>
                    <td className="px-4 py-4 capitalize text-[#1a1a1a] font-[500] text-[14px]">
                      {d?.operation}
                    </td>
                    <td className="px-4 py-4 text-gray-600 font-[400] text-[13px] font-mono">
                      {BASE_URL}/post-back/{organization?.id}
                      /[%transaction_id%]/{d?.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Postback;
